// import React, { use, useEffect, useState, useContext } from "react";
// import {
//   Outlet,
//   useLocation,
//   useNavigate,
//   UNSAFE_NavigationContext as NavigationContext,
// } from "react-router-dom";
// import {
//   AppBar,
//   Toolbar,
//   Typography,
//   IconButton,
//   Box,
//   Drawer,
//   CssBaseline,
//   Tooltip,
//   Avatar,
//   Menu,
//   MenuItem,
//   List,
//   Button,
//   ListItemButton,
//   ListItemText,
//   Divider,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogContentText,
//   DialogActions
// } from "@mui/material";
// import MenuIcon from "@mui/icons-material/Menu";
// import { motion, AnimatePresence } from "framer-motion";
// import LogoutIcon from "@mui/icons-material/Logout";
// import logo from "../assets/images/logo.svg";
// import favIcon from "../assets/images/favicon_Sandhata.png";
// import { useAuth } from "../auth/AuthContext";
// import { useApi } from "../api/useApi";
// import GradientLayout from "./GradientLayout";
// import Greeting from "./Greeting";
// import { useRef, useLayoutEffect } from "react";
// import Snackbar from "@mui/material/Snackbar";
// import Alert from "@mui/material/Alert";
// import ContactUsPopup from "../components/ContactusPage";
// export const UnsavedContext = React.createContext({
//   hasUnsaved: false,
//   setHasUnsaved: () => {},
// });

// const IconCompleted = () => (
//   <svg
//     xmlns="http://www.w3.org/2000/svg"
//     width="16"
//     height="16"
//     viewBox="0 0 16 16"
//     fill="none"
//   >
//     <path
//       fill-rule="evenodd"
//       clip-rule="evenodd"
//       d="M8 1C4.1 1 1 4.1 1 8C1 11.9 4.1 15 8 15C11.9 15 15 11.9 15 8C15 4.1 11.9 1 8 1ZM7 10.7004L4.5 8.20039L5.3 7.40039L7 9.10039L10.7 5.40039L11.5 6.20039L7 10.7004ZM2 8C2 11.3 4.7 14 8 14C11.3 14 14 11.3 14 8C14 4.7 11.3 2 8 2C4.7 2 2 4.7 2 8Z"
//       fill="#0067d6ff"
//     />
//   </svg>
// );

// const IconHalfFilled = () => (
//   <svg
//     xmlns="http://www.w3.org/2000/svg"
//     width="16"
//     height="16"
//     viewBox="0 0 16 16"
//     fill="none"
//   >
//     <path
//       d="M8 15C6.14348 15 4.36256 14.2629 3.0498 12.9502C1.73705 11.6374 1 9.85652 1 8C1 6.14348 1.73705 4.36256 3.0498 3.0498C4.36256 1.73705 6.14348 1 8 1V15ZM12.5244 13.3359C11.9037 13.8613 11.1963 14.2746 10.4336 14.5566L10.0918 13.6172C10.7448 13.3749 11.3506 13.0208 11.8818 12.5703L12.5244 13.3359ZM14.8887 9.20605C14.7504 10.0122 14.4739 10.7886 14.0703 11.5L13.2041 11C13.5494 10.3897 13.787 9.72434 13.9053 9.0332L14.8887 9.20605ZM14.0703 4.52246C14.4737 5.22577 14.7504 5.99503 14.8887 6.79395L13.9053 7C13.7871 6.29836 13.5496 5.622 13.2041 5L14.0703 4.52246ZM10.4336 1.44336C11.1963 1.72539 11.9037 2.13871 12.5244 2.66406L11.8818 3.42969C11.3506 2.97911 10.7449 2.6241 10.0918 2.38184L10.4336 1.44336Z"
//       fill="#0036DD"
//     />
//   </svg>
// );

// const IconNotStarted = () => (
//   <svg
//     xmlns="http://www.w3.org/2000/svg"
//     width="16"
//     height="16"
//     viewBox="0 0 16 16"
//     fill="none"
//   >
//     <path
//       d="M10.1514 14.6514C9.44847 14.8408 8.72767 14.9577 8.00098 15.001V14.001C8.62977 14.003 9.25465 13.9018 9.85059 13.7012L10.1514 14.6514ZM4.50098 12.8506C5.00708 13.212 5.56324 13.4989 6.15137 13.7012L5.85059 14.6514C5.15363 14.4196 4.49635 14.082 3.90137 13.6514L4.50098 12.8506ZM13.6514 12.1006C13.2124 12.6895 12.6895 13.2124 12.1006 13.6514L11.501 12.8506C12.0227 12.4788 12.4788 12.0227 12.8506 11.501L13.6514 12.1006ZM2.30078 9.90137C2.50301 10.4894 2.78997 11.0448 3.15137 11.5508L2.35059 12.1514C1.91973 11.5562 1.58247 10.8984 1.35059 10.2012L2.30078 9.90137ZM15.001 8.00098C14.9863 8.73055 14.8689 9.45481 14.6514 10.1514L13.7012 9.85059C13.9018 9.25465 14.003 8.62977 14.001 8.00098H15.001ZM2.30078 6.15137C2.1002 6.74731 1.99895 7.37219 2.00098 8.00098H1.00098C0.990995 7.26936 1.10907 6.54127 1.35059 5.85059L2.30078 6.15137ZM13.6006 3.85059C14.0314 4.44568 14.3687 5.10366 14.6006 5.80078L13.6514 6.10059C13.4491 5.51255 13.1622 4.9572 12.8008 4.45117L13.6006 3.85059ZM4.45117 3.15137C3.95619 3.53748 3.51855 3.99179 3.15137 4.50098L2.35059 3.90137C2.77163 3.31376 3.2771 2.79067 3.85059 2.35059L4.45117 3.15137ZM10.1006 1.30078C10.7977 1.53264 11.4557 1.86997 12.0508 2.30078L11.4512 3.10059C10.9451 2.73913 10.3889 2.45321 9.80078 2.25098L10.1006 1.30078ZM8.00098 2.00098C7.37219 1.99895 6.74731 2.1002 6.15137 2.30078L5.85059 1.35059C6.54127 1.10907 7.26936 0.990995 8.00098 1.00098V2.00098Z"
//       fill="#DDC9C9"
//     />
//   </svg>
// );

// const drawerWidth = 240;

// export default function MainLayout() {
//   const location = useLocation();
//   const navigate = useNavigate();
//   const isActive = (path) => location.pathname.includes(path);

//   const { user, logout } = useAuth();
//   const hideLayout = ["/", "/login"].includes(location.pathname);
//   const [mobileOpen, setMobileOpen] = useState(false);
//   const [anchorEl, setAnchorEl] = useState(null);
//   const [domains, setDomains] = useState([]);
//   const { request } = useApi();
//   const [activeDomain, setActiveDomain] = useState(user.domain);
//   const [Opencontactus, setOpencontactus] = useState(false);
//   // const [showInstriction, setShowInstruction] = useState(false);

//   const [contactPopupOpen, setContactPopupOpen] = useState(false);
//   const [pendingContactClick, setPendingContactClick] = useState(false);
//   const [imageUrl, setImgUrl] = useState(null);
//   const [initial, setInitial] = useState("XZ");
//   const open = Boolean(anchorEl);
//   const [assessmentAvailable, setAssessmentAvailable] = useState(true);
//   const [checkedCompletion, setCheckedCompletion] = useState(false);
//   const [domainAssessmentAllowed, setDomainAssessmentAllowed] = useState(true);
//   const sendingRef = useRef(false);

//   const [hasCompleted, setHasCompleted] = useState(null);
//   const [domainData, setDomainData] = useState([]);

//   const [notifMessage, setNotifMessage] = useState("");
//   const [unsavedSnackOpen, setUnsavedSnackOpen] = useState(false);

//   const pendingCallback = useRef(null);
//   const [openConfirm, setOpenConfirm] = useState(false);
//   const pendingAction = useRef(null);
//   // 🔥 Global flag: Are there unsaved changes in Questions.jsx?
//   const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
//   const [activeCategory, setActiveCategory] = useState(null);
//   const [categoryStatus, setCategoryStatus] = useState({});
//   const [blockTriggered, setBlockTriggered] = useState(false);
//   const isQuestionsPage = location.pathname.startsWith("/questions/");
//   const [userData, setUserData] = useState();
//   const [successOpen, setSuccessOpen] = useState(false);
//   const [successMessage, setSuccessMessage] = useState("");
//   const isDashboardActive = location.pathname === "/history-page" ? true : false;
//   const isLandingActive = location.pathname === "/landing-page" ? true : false;
//   const showInstriction = location.pathname !== "/landing-page" ? true : false;

//   const handleBlockedNavigation = (nextAction) => {
//     if (hasUnsavedChanges) {
//       pendingAction.current = nextAction;
//       setOpenConfirm(true);
//       return false;
//     }

//     return true;
//   };

//   const handleYes = () => {
//     setOpenConfirm(false);

//     const callback = pendingCallback.current;

//     setHasUnsavedChanges(false);

//     setTimeout(() => {
//       if (callback) {
//         callback();
//       }

//       pendingCallback.current = null;
//     }, 100);
//   };
//   const handleNo = () => {
//     setOpenConfirm(false);
//     pendingCallback.current = null;
//   };

//   const WarningBanner = ({ open, message, onClose }) => {
//     return (
//       <AnimatePresence>
//         {open && (
//           <motion.div
//             initial={{ y: 50, opacity: 0 }}
//             animate={{ y: 0, opacity: 1 }}
//             exit={{ y: 50, opacity: 0 }}
//             transition={{ duration: 0.4, ease: "easeOut" }}
//             style={{
//               position: "fixed",
//               bottom: "2rem", // stay at bottom
//               left: "35%", // center horizontally
//               transform: "translateX(-50%)", // perfectly center it
//               display: "inline-flex",
//               alignItems: "center",
//               gap: "1rem",
//               borderRadius: "1rem",
//               border: "1px solid #D32F2F",
//               background: "#D32F2F",
//               color: "#FFFFFF",
//               // fontFamily: "Akkurat-Bold, sans-serif",
//               "& .MuiTypography-root": {
//                 fontFamily: "Montserrat",
//               },
//               fontSize: "0.9rem",
//               fontWeight: 400,
//               padding: "0.75rem 1.25rem",
//               zIndex: 2000,
//               boxShadow: "0 2px 10px rgba(0, 0, 0, 0.25)",
//               textAlign: "center",
//               maxWidth: "90%",
//             }}
//           >
//             {/* Warning Icon */}
//             <svg
//               xmlns="http://www.w3.org/2000/svg"
//               width="20"
//               height="20"
//               viewBox="0 0 24 24"
//               fill="none"
//             >
//               <circle cx="12" cy="12" r="10" stroke="#fff" strokeWidth="2" />
//               <line
//                 x1="12"
//                 y1="7"
//                 x2="12"
//                 y2="13"
//                 stroke="#fff"
//                 strokeWidth="2"
//                 strokeLinecap="round"
//               />
//               <circle cx="12" cy="17" r="1.3" fill="#fff" />
//             </svg>

//             {/* Message */}
//             <span>{message}</span>

//             {/* Close Button */}
//             <Box
//               onClick={onClose}
//               sx={{
//                 cursor: "pointer",
//                 ml: 1,
//               }}
//             >
//               <svg
//                 xmlns="http://www.w3.org/2000/svg"
//                 width="18"
//                 height="18"
//                 viewBox="0 0 24 24"
//                 stroke="#fff"
//                 strokeWidth="2"
//               >
//                 <line x1="6" y1="6" x2="18" y2="18" strokeLinecap="round" />
//                 <line x1="18" y1="6" x2="6" y2="18" strokeLinecap="round" />
//               </svg>
//             </Box>
//           </motion.div>
//         )}
//       </AnimatePresence>
//     );
//   };

//   const SuccessBanner = ({ open, message }) => {
//     return (
//       <AnimatePresence>
//         {open && (
//           <motion.div
//             initial={{ y: 50, opacity: 0 }}
//             animate={{ y: 0, opacity: 1 }}
//             exit={{ y: 50, opacity: 0 }}
//             transition={{ duration: 0.4, ease: "easeOut" }}
//             style={{
//               position: "fixed",
//               bottom: "2rem",
//               left: "35%",
//               transform: "translateX(-50%)",
//               display: "inline-flex",
//               alignItems: "center",
//               gap: "1rem",
//               borderRadius: "1rem",
//               border: "1px solid #00A300",
//               background: "#016100",
//               color: "#FFFFFF",
//               // fontFamily: "Akkurat-Bold, sans-serif",
//               fontSize: "0.9rem",
//               fontWeight: 400,
//               padding: "0.75rem 1.25rem",
//               zIndex: 2000,
//               boxShadow: "0 2px 10px rgba(0, 0, 0, 0.25)",
//               textAlign: "center",
//               maxWidth: "90%",
//             }}
//           >
//             <svg
//               xmlns="http://www.w3.org/2000/svg"
//               width="20"
//               height="20"
//               viewBox="0 0 20 20"
//               fill="none"
//             >
//               <path
//                 fillRule="evenodd"
//                 clipRule="evenodd"
//                 d="M10 1.25C5.125 1.25 1.25 5.125 1.25 10C1.25 14.875 5.125 18.75 10 18.75C14.875 18.75 18.75 14.875 18.75 10C18.75 5.125 14.875 1.25 10 1.25ZM8.75 13.75L5.375 10.375L6.5 9.375L8.75 11.625L13.75 6.75L14.875 7.75L8.75 13.75Z"
//                 fill="#24A148"
//               />
//             </svg>

//             <span>{message}</span>
//           </motion.div>
//         )}
//       </AnimatePresence>
//     );
//   };

//   // Track previous route inside the SPA
//   const previousPath = useRef("");
//   const pendingRoute = useRef(null);
//   const originalPushRef = useRef(null);
//   const { navigator } = useContext(NavigationContext);
//   useEffect(() => {
//     const handleBeforeUnload = (e) => {
//       if (!hasUnsavedChanges) return;
//       e.preventDefault();
//       e.returnValue = "";
//     };

//     window.addEventListener("beforeunload", handleBeforeUnload);
//     return () => window.removeEventListener("beforeunload", handleBeforeUnload);
//   }, [hasUnsavedChanges]);

//   useEffect(() => {
//     async function fetchDomains() {
//       const data = await request({
//         url: "/categories/domains-with-categories",
//       });

//       // Full data (domain + categories)
//       setDomainData(data);

//       // Keep names array — your existing logic depends on this
//       const domainNames = data.map((item) => item.name);
//       setDomains(domainNames);
//     }
//     fetchDomains();
//     const initials = user.name
//       ? user.name
//           .split(" ")
//           .map((n) => n[0])
//           .join("")
//           .substring(0, 2)
//           .toUpperCase()
//       : "";
//     setInitial(initials);
//   }, []);

//   useEffect(() => {
//     if (!location.pathname.startsWith("/questions/")) return;

//     // Wait for Questions.jsx to update localStorage
//     const timer = setTimeout(() => {
//       const saved = localStorage.getItem("activeCategory");
//       setActiveCategory(saved);
//     }, 50);

//     return () => clearTimeout(timer);
//   }, [location.pathname]);

//   // Listen for category change updates from Questions.jsx
//   useEffect(() => {
//     const handler = () => {
//       const saved = localStorage.getItem("activeCategory");
//       setActiveCategory(saved);
//     };

//     window.addEventListener("storage", handler);
//     return () => window.removeEventListener("storage", handler);
//   }, []);

//   useEffect(() => {
//     const handler = () => {
//       const saved = localStorage.getItem("activeCategory");
//       setActiveCategory(saved);
//     };

//     window.addEventListener("activeCategoryChanged", handler);
//     return () => window.removeEventListener("activeCategoryChanged", handler);
//   }, []);

//   useEffect(() => {
//     const handler = () => {
//       const savedStatus = localStorage.getItem("categoryStatus");
//       if (savedStatus) {
//         setCategoryStatus(JSON.parse(savedStatus));
//       }
//     };

//     window.addEventListener("categoryStatusUpdated", handler);

//     return () => window.removeEventListener("categoryStatusUpdated", handler);
//   }, []);

//   useEffect(() => {
//     let urlDomain = null;

//     // Case 1: Question pages → /questions/DevOps
//     if (location.pathname.startsWith("/questions/")) {
//       urlDomain = location.pathname.split("/")[2];
//     }

//     // Case 2: Score pages → /sre-score?domain=DevOps
//     if (
//       location.pathname.startsWith("/sre-score") ||
//       location.pathname.startsWith("/devops-score")
//     ) {
//       const params = new URLSearchParams(location.search);
//       urlDomain = params.get("domain");
//     }

//     if (urlDomain) {
//       const matched = domains.find(
//         (d) => d.toLowerCase() === urlDomain.toLowerCase(),
//       );
//       if (matched) setActiveDomain(matched);
//     }
//   }, [location.pathname, domains]);

//   useEffect(() => {
//     if (!user?.email) return;

//     async function checkStatus() {
//       try {
//         const res = await request({
//           url: `evaluations/has-completed/${user.email}`,
//           method: "GET",
//         });

//         setHasCompleted(res);
//         // If user has completed → redirect ONCE only
//         // if (res === true) {
//         //   setShowInstruction(true)
//         //   if (!location.pathname.startsWith("/history-page")) {
//         //     navigate("/history-page", { replace: true });
//         //   }
//         // }
//         //  if (res === false) {
//         //   setShowInstruction(false);
//         if (!location.pathname.startsWith("/landing-page")) {
//           navigate("/landing-page", { replace: true });
//         }
//         // }
//       } catch (err) {
//         console.error(err);
//       }

//       setCheckedCompletion(true);
//     }

//     checkStatus();
//   }, [user?.email]);

//   useLayoutEffect(() => {
//     if (!checkedCompletion) return;

//     const isQuestionsPage = location.pathname.startsWith("/questions/");
//     const isMaturityAssessmentPage = location.pathname.startsWith("/sre-score");

//     if (hasCompleted === false) return;

//     const allowedPrev = [
//       "/history-page",
//       "/final-page",
//       "/sre-score",
//       "/devops-score",
//     ];

//     const cameFromAllowed = allowedPrev.some((p) =>
//       previousPath.current.startsWith(p),
//     );

//     const lastPath = previousPath.current;
//     previousPath.current = location.pathname;

//     if (isQuestionsPage) {
//       // Allow switching between domain question pages
//       const cameFromQuestions = previousPath.current.startsWith("/questions/");

//       if (cameFromQuestions) {
//         // allow navigation
//         previousPath.current = location.pathname;
//         return;
//       }

//       // Otherwise fall back to strict rule
//       if (!cameFromAllowed) {
//         navigate("/history-page");
//       }
//     }
//   }, [location.pathname, checkedCompletion, hasCompleted]);

//   if (!checkedCompletion) return null;

//   if (hideLayout || !user) return <Outlet />;

// const showUnsavedChangesDialog = (onYes) => {
//     pendingCallback.current = onYes;
//     setOpenConfirm(true);
//   };

//   const handleClick = async (domain) => {
//     if (hasUnsavedChanges) {
//       showUnsavedChangesDialog(() => {
//         // continue action here
//         navigate(`/questions/${domain}`);
//         console.log("User clicked YES");
//       });
//     }

//     try {
//       const res = await request({
//         url: `/evaluations/has-completed/${user.email}?domain=${domain}`,
//         method: "GET",
//       });

//       setDomainAssessmentAllowed(res);
//     } catch (err) {
//       console.error("Domain assessment check failed:", err);
//       setDomainAssessmentAllowed(false);
//     }

//     // ✔ Only navigate — highlight will update in useEffect after navigation succeeds
//     navigate(`/questions/${domain}`);
//   };

//   function NavigationBlocker({ when, onBlock }) {
//     const { navigator } = useContext(NavigationContext);

//     useEffect(() => {
//       if (!when) return;

//       const originalPush = navigator.push;

//       navigator.push = (...args) => {
//         onBlock(args, originalPush);
//         return; // block navigation
//       };

//       return () => {
//         navigator.push = originalPush;
//       };
//     }, [when, onBlock, navigator]);

//     return null;
//   }

//   const handleDrawerToggle = () => setMobileOpen(!mobileOpen);
//   const handleMenuOpen = (event) => setAnchorEl(event.currentTarget);
//   const handleMenuClose = () => setAnchorEl(null);
//   //const handleLogout = () => {};
//   const handleLogout = () => {
//     if (hasUnsavedChanges) {
//       setNotifMessage(
//         "You have unsaved changes. Please click SAVE before continuing.",
//       );
//       setUnsavedSnackOpen(true);

//       setTimeout(() => setUnsavedSnackOpen(false), 3000);
//       return; // ⛔ block logout
//     }

//     logout(); // ✔ safe logout
//   };

//   // Dynamic greeting
//   const greeting = (() => {
//     const hour = new Date().getHours();
//     if (hour < 12) return "Good Morning";
//     if (hour < 18) return "Good Afternoon";
//     return "Good Evening";
//   })();

//   const avatarSrc = user?.imageUrl || user?.photo || null;
//   const initials =
//     user?.name
//       ?.split(" ")
//       ?.map((n) => n[0])
//       .join("")
//       .substring(0, 2)
//       .toUpperCase() || "NA";

//   const menuItems = [
//     { text: "DevOps Questions", path: "/devops-questions", domain: "DevOps" },
//     {
//       text: "Questionaire",
//       path: `/sre-questions?email=${user.email}&domain=${user.domain}`,
//       domain: "SRE",
//     },
//     { text: "DevOps Score", path: "/devops-score", domain: "DevOps" },
//     {
//       text: "Maturity Assessment",
//       path: `/sre-score?email=${user.email}&domain=${user.domain}`,
//       domain: "SRE",
//     },
//     { text: "Contact Us", path: "/contactus-page", domain: "All" },
//   ];

//   const bottomItem = { text: "Preview Instructions", path: "/instructions" };

//   const filteredMenuItems = menuItems.filter(
//     (item) => item.domain === user.domain || item.domain === "All",
//   );

//   const handleContactUs = async () => {
//     if (sendingRef.current) return; // ⛔ prevent double-click
//     sendingRef.current = true;

//     try {
//       const requests = await request({
//         url: "/user/by-email",
//         method: "GET",
//         params: { email: user.email },
//       });

//       if (requests[0]?.emailId) {
//         //   await request({
//         //   url: `user/logout?email=${requests[0]?.emailId}`,
//         //   method: "GET",
//         // });
//         // sessionStorage.removeItem("user");
//         // // navigate("/");
//         setUserData(requests[0]);
//         setOpencontactus(true)
//         // navigate("/contactus-page", {
//         //   state: {
//         //     // email: user?.email,
//         //     // name: user?.name,
//         //     email: requests[0]?.emailId,
//         //     name: requests[0]?.userName,
//         //     phone:requests[0]?.phoneNumber,
//         //     userDomain:requests[0]?.userDomain,
//         //     userRole:requests[0]?.userRole,
//         //     remarks:requests[0]?.remarks,
//         //     jobTitle:requests[0]?.jobTitle,
//         //     organisation:requests[0]?.organisation,
//         //     // userLogedIn:true
//         //   },
//         // });
//         // navigate("/contactus-page");
//         // sendingRef.current = false;
//         // return;
//       }

//       // Check if user exists
//       // const res = await request({
//       //   url: "/user/exists",
//       //   method: "GET",
//       //   params: { email: user.email },
//       // });

//       // if (res.exists) {
//       //   // Trigger email once
//       //   await request({
//       //     url: "/contact/trigger-email",
//       //     method: "POST",
//       //     params: {
//       //       email: user.email,
//       //       name: user.name || "User",
//       //     },
//       //   });

//       //   // Show green success banner
//       //   setSuccessMessage("Thank you! We will contact you shortly.");
//       //   setSuccessOpen(true);

//       //   setTimeout(() => setSuccessOpen(false), 3000);
//       // } else {
//       //   navigate("/contactus-page");
//       // }
//     } catch (err) {
//       console.error(err);
//       setNotifMessage("Unable to process request. Try again.");
//       setUnsavedSnackOpen(true);
//     }
//     setTimeout(() => {
//       sendingRef.current = false; // unlock after 400ms
//     }, 400);
//   };

//   // Sidebar
//   const drawer = (
//     <Box
//       sx={{
//         display: "flex",
//         flexDirection: "column",
//         height: "85%",
//         py: 2,
//         backgroundColor: "whitesmoke",
//         color: "black",
//         alignItems: "center",
//         justifyContent: "space-between",
//       }}
//     >
//       {/* === Top Section === */}
//       <Box sx={{ width: "100%", textAlign: "center" }}>
//         <Box
//           component="img"
//           src={logo}
//           alt="Portal Logo"
//           sx={{
//             width: "160px",
//             height: "auto",
//             filter: "drop-shadow(0 2px 3px rgba(0,0,0,0.2))",
//           }}
//         />

//         <Box sx={{ mt: 3, px: 2, textAlign: "left" }}>
//           <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1 }}>
//             Domain
//           </Typography>

//           {domains.map((domain) => {
//             const isQuestionsPage = location.pathname.startsWith("/questions/");

//             return (
//               <ListItemButton
//                 key={domain}
//                 disableRipple
//                 sx={{
//                   p: 1,
//                   "&.Mui-selected": {
//                     backgroundColor: "transparent",
//                   },
//                   "&.Mui-focusVisible": {
//                     backgroundColor: "transparent",
//                   },
//                   "&:hover": {
//                     backgroundColor: "transparent",
//                   },
//                 }}
//                 selected={isQuestionsPage && activeDomain === domain}
//                 //onClick={() => navigate(`/${domain.toLowerCase()}-questions`)}
//                 onClick={() => handleClick(domain)}
//               >
//                 <ListItemText
//                   slotProps={{
//                     primary: {
//                       sx: {
//                         borderRight:
//                           isQuestionsPage && activeDomain === domain
//                             ? "3px solid #1976d2"
//                             : "none",

//                         color:
//                           isQuestionsPage && activeDomain === domain
//                             ? "#0036DD"
//                             : "#000",

//                         // fontFamily:
//                         //   isQuestionsPage && activeDomain === domain
//                         //     ? "Akkurat-Bold"
//                         //     : "Akkurat",

//                         fontWeight:
//                           isQuestionsPage && activeDomain === domain
//                             ? "700"
//                             : "400",
//                       },
//                     },
//                   }}
//                   primary={domain}
//                 />
//               </ListItemButton>
//             );
//           })}
//         </Box>
//       </Box>

//       {/* === Bottom Section (Preview Instructions) === */}
//       <Box sx={{ width: "100%", textAlign: "left" }}>
//         <Button
//           fullWidth
//           onClick={() => navigate(bottomItem.path)}
//           sx={{
//             textTransform: "none",
//             color: "black",
//             fontWeight: 500,
//             "&:hover": { color: "#1976d2" },
//           }}
//         >
//           {bottomItem.text}
//         </Button>
//       </Box>
//     </Box>
//   );
//   const handleCategoryClick = (catName) => {
//     localStorage.setItem("activeStepCategory", catName);
//     window.dispatchEvent(new Event("localStorageChange"));
//   };
//   return (
//     <UnsavedContext.Provider
//       value={{
//         hasUnsaved: hasUnsavedChanges,
//         setHasUnsaved: setHasUnsavedChanges,
//       }}
//     >
//       <>
//         {/* 🔥 Navigation blocker added here */}
//         <NavigationBlocker
//           when={hasUnsavedChanges}
//           onBlock={(args) => {
//             const nextLocation = args[0];

//             showUnsavedChangesDialog(() => {
//               navigate(nextLocation.pathname);
//             });
//           }}
//         />

//         <Dialog open={openConfirm} onClose={handleNo}>
//           <DialogTitle>Unsaved Changes</DialogTitle>

//           <DialogContent>
//             <DialogContentText>
//               You have unsaved changes. Do you want to leave this page?
//             </DialogContentText>
//           </DialogContent>

//           <DialogActions>
//             <Button onClick={handleNo}>No</Button>

//             <Button onClick={handleYes} variant="contained" color="primary">
//               Yes
//             </Button>
//           </DialogActions>
//         </Dialog>

//         {/* <Box sx={{ display: "flex", height: "100vh", scrollbarWidth: "none", scrollbarHeight: "none" }}> */}
//         <Box
//           sx={{
//             display: "flex",
//             height: "100vh",
//             overflow: "hidden", // ⛔ Hides entire page vertical scroll
//           }}
//         >
//           {/* Sidebar */}
//           <Box
//             sx={{
//               display: "flex",
//               flexDirection: "column",
//               alignItems: "flex-start",
//               width: "13.125rem",
//               // height: "100%",
//               padding: "1rem 0 1rem 1rem",
//               gap: "1.5rem",
//               flexShrink: 0,
//               backgroundColor: "#FFF",
//               boxShadow: "1px 0 2px 0 rgba(0, 0, 0, 0.10)",
//               zIndex: 4,
//             }}
//           >
//             {/* Logo */}
//             <Box
//               sx={{
//                 display: "flex",
//                 flexDirection: "column",
//                 alignItems: "flex-start",
//                 gap: "0.625rem", // 10px
//               }}
//             >
//               <Box
//                 component="img"
//                 src={logo}
//                 alt="Logo"
//                 sx={{
//                   width: "120px", // 120px
//                   height: "22.4px", // ~22px
//                   // objectFit: "contain",   // keeps the logo proportional
//                 }}
//               />
//             </Box>

//             {/* List Items */}
//             <Box
//               sx={{
//                 display: "flex",
//                 flexDirection: "column",
//                 justifyContent: "space-between",
//                 pl: 2,
//                 height: "100%",
//               }}
//             >
//               <Box>
//                 <Box
//                   sx={{
//                     display: "flex",
//                     padding: "0.375rem 0", // 6px top & bottom
//                     justifyContent: "center",
//                     alignItems: "center",
//                     gap: "0.625rem", // 10px gap between items
//                     alignSelf: "stretch", // take full width of parent
//                   }}
//                 >
//                   <Typography
//                     sx={{
//                       width: "11.375rem", // 182px
//                       color: "#1F2A54",
//                       "& .MuiTypography-root": {
//                         fontFamily: "Montserrat",
//                       },
//                       fontSize: "0.875rem", // 14px
//                       fontWeight: 700,
//                       fontStyle: "normal",
//                       lineHeight: "normal",
//                       fontFeatureSettings: "'liga' off, 'clig' off",
//                     }}
//                   >
//                     Domains
//                   </Typography>
//                 </Box>
//                 <Divider sx={{ color: "light grey", mt: 1, mb: "24px" }} />
//                 <Box
//                   sx={{
//                     display: "flex",
//                     flexDirection: "column",
//                     gap: "1rem",
//                     px: 0,
//                   }}
//                 >
//                   {domainData.map((d) => {
//                     const domain = d.name;
//                     const isQuestionsPage =
//                       location.pathname.startsWith("/questions/");
//                     const shouldHighlightDomain =
//                       isQuestionsPage && activeDomain === domain;
//                     let sortedData = [...d.categories].sort((a, b) =>
//                       b.weightage !== a.weightage
//                         ? b.weightage - a.weightage
//                         : a.name.localeCompare(b.name),
//                     );
//                     const lastSavedStep =
//                       localStorage.getItem("activeCategory");
//                     // console.log("lastSavedStep=====>",lastSavedStep)
//                     let activeStepindex = sortedData.findIndex(
//                       (item) => item.name == lastSavedStep,
//                     );
//                     return (
//                       <Box key={domain} sx={{ width: "100%" }}>
//                         {/* ===== Domain Title ===== */}
//                         <Box
//                           onClick={() => handleClick(domain)}
//                           sx={{
//                             display: "flex",
//                             gap: "0.25rem",
//                             alignItems: "center",
//                             height: "32px",
//                             cursor: "pointer",
//                             //pl: 1,

//                             borderLeft: shouldHighlightDomain
//                               ? "3px solid #0036DD"
//                               : "3px solid transparent",
//                             backgroundColor: shouldHighlightDomain
//                               ? "#F6F8FF"
//                               : "transparent",
//                             "&:hover": { backgroundColor: "#f5f5f5" },
//                           }}
//                         >
//                           <Typography
//                             sx={{
//                               fontSize: "0.75rem",
//                               pl: shouldHighlightDomain ? 1 : 0,
//                               fontFamily: shouldHighlightDomain
//                                 ? "Akkurat-Bold"
//                                 : "Akkurat-Bold",
//                               fontWeight: shouldHighlightDomain ? 400 : 400,
//                               color: shouldHighlightDomain ? "#0036DD" : "#000",
//                             }}
//                           >
//                             {domain}
//                           </Typography>
//                         </Box>

//                         {/* ===== Categories under Active Domain ===== */}
//                         {isQuestionsPage && activeDomain === domain && (
//                           <Box
//                             sx={{
//                               mt: 0,
//                               display: "flex",
//                               flexDirection: "column",
//                               pl: 0,
//                             }}
//                           >
//                             {[...d.categories]
//                               .sort((a, b) =>
//                                 b.weightage !== a.weightage
//                                   ? b.weightage - a.weightage
//                                   : a.name.localeCompare(b.name),
//                               )
//                               .map((cat, index) => {
//                                 // activeCategory === cat.name;
//                                 const isCompleted =
//                                   categoryStatus?.[cat.name]?.allAnswered;
//                                 const hasProgress =
//                                   categoryStatus?.[cat.name]?.anyAnswered;
//                                 const isActiveCategory =
//                                   index == activeStepindex;

//                                 return (
//                                   <Box
//                                     key={cat.id}
//                                     sx={{
//                                       display: "flex",
//                                       alignItems: "center",
//                                       gap: "0.4rem",
//                                       // py: "2px",
//                                       cursor: "default",
//                                       p: 1,
//                                       borderLeft:
//                                         isActiveCategory || isCompleted
//                                           ? "3px solid #0036DD"
//                                           : "3px solid transparent",
//                                     }}
//                                     onClick={() =>
//                                       handleCategoryClick(cat.name)
//                                     }
//                                   >
//                                     {/* ===== Icon : Completed / Half / Empty ===== */}
//                                     {isCompleted ? (
//                                       <IconCompleted />
//                                     ) : hasProgress ? (
//                                       <IconHalfFilled />
//                                     ) : (
//                                       <IconNotStarted />
//                                     )}

//                                     {/* ===== Category Text ===== */}
//                                     <Typography
//                                       sx={{
//                                         fontSize: "0.75rem",
//                                         color: "#000",
//                                         fontFamily: "Akkurat-Pro",
//                                         fontWeight: isActiveCategory
//                                           ? 400
//                                           : 400,
//                                         pt: 0,
//                                       }}
//                                     >
//                                       {cat.name}
//                                     </Typography>
//                                   </Box>
//                                 );
//                               })}
//                           </Box>
//                         )}
//                       </Box>
//                     );
//                   })}
//                 </Box>
//               </Box>
//               {/* {showInstriction && ( */}
//                 <Box sx={{ display: "flex" }}>
//                   <Box
//                     disableRipple
//                     component={Button}
//                     onClick={() => navigate("/instructions")}
//                     sx={{
//                       width: "11.375rem",
//                       mb: 0,
//                       flexShrink: 0,
//                       p: 0,
//                       m: 0,
//                       textTransform: "none",
//                       display: "flex",
//                       justifyContent: "flex-start",
//                     }}
//                   >
//                     <Typography
//                       sx={{
//                         color: "#1F2A54",
//                         // fontFamily: "Montserrat",
//                         "& .MuiTypography-root": {
//                           fontFamily: "Montserrat",
//                         },
//                         fontSize: "0.875rem", // 14px
//                         fontWeight: 400,
//                         fontStyle: "normal",
//                         lineHeight: "normal",
//                         fontFeatureSettings: "'liga' off, 'clig' off",
//                       }}
//                     >
//                       Instruction
//                     </Typography>
//                   </Box>
//                 </Box>
//               {/* )} */}
//             </Box>
//           </Box>

//           {/* Main content area */}
//           <Box sx={{ flexGrow: 1, display: "flex", flexDirection: "column" }}>
//             {/* AppBar */}
//             <Box
//               sx={{
//                 display: "flex",

//                 width: "auto",
//                 height: "2.875rem",
//                 // padding: "0 4rem 0 1.5rem",
//                 alignItems: "center",
//                 gap: "1.5rem",
//                 flexShrink: 0,
//                 background: "#FFF",
//                 boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.10)",
//                 zIndex: 4,
//               }}
//             >
//               {/* Navigation and profile */}
//               <Box
//                 sx={{
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "space-between",
//                   width: "100%",
//                 }}
//               >
//                 <Box sx={{ display: "flex", flexDirection: "row", gap: 1 }}>
//                   {/* Greeting */}
//                   <Box
//                     sx={{
//                       display: "flex",
//                       padding: "0 0.625rem", // 0 top/bottom, 0.625rem (~10px) left/right
//                       justifyContent: "center",
//                       alignItems: "center",
//                       gap: "0.625rem", // 10px gap between items
//                       alignSelf: "stretch", // take full width of parent
//                     }}
//                   >
//                     <Typography
//                       sx={{
//                         color: "#000",
//                         fontFamily: "Akkurat-Bold",
//                         fontSize: "0.75rem", // 12px
//                         fontWeight: 400,
//                         fontStyle: "normal",
//                         lineHeight: "normal",
//                         fontFeatureSettings: "'liga' off, 'clig' off",
//                       }}
//                     >
//                       <Greeting />
//                     </Typography>
//                   </Box>
//                   <Box
//                     disableRipple
//                     component={Button}
//                     onClick={() => {
//                       navigate("/landing-page");
//                     }}
//                     sx={{
//                       position: "relative",
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "center",
//                       px: "0.75rem",
//                       height: "100%",
//                       textTransform: "none",
//                       borderRadius: 0,

//                       backgroundColor: isLandingActive
//                         ? "#EEF3FF"
//                         : "transparent",

//                       "&:hover": {
//                         backgroundColor: isLandingActive
//                           ? "#EEF3FF"
//                           : "transparent",
//                       },
//                     }}
//                   >
//                     <Typography
//                       sx={{
//                         fontSize: "0.85rem",
//                         fontFamily: "Akkurat-Pro",
//                         fontWeight: 500,
//                         color: isLandingActive ? "#0036DD" : " #000",
//                       }}
//                     >
//                       Home
//                     </Typography>

//                     {isLandingActive && (
//                       <Box
//                         sx={{
//                           position: "absolute",
//                           bottom: 0,
//                           left: 0,
//                           width: "100%",
//                           height: "2px",
//                           backgroundColor: "#0036DD",
//                         }}
//                       />
//                     )}
//                   </Box>
//                   <Box
//                     disableRipple
//                     component={Button}
//                     onClick={() => navigate("/history-page")}
//                     sx={{
//                       position: "relative",
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "center",
//                       px: "0.75rem",
//                       height: "100%",
//                       textTransform: "none",
//                       borderRadius: 0,

//                       backgroundColor: isDashboardActive
//                         ? "#EEF3FF"
//                         : "transparent",

//                       "&:hover": {
//                         backgroundColor: isDashboardActive
//                           ? "#EEF3FF"
//                           : "transparent",
//                       },
//                     }}
//                   >
//                     <Typography
//                       sx={{
//                         fontSize: "0.85rem",
//                         fontFamily: "Akkurat-Pro",
//                         fontWeight: 500,
//                         color: isDashboardActive ? "#0036DD" : "#000",
//                       }}
//                     >
//                       Dashboard
//                     </Typography>

//                     {/* ✅ Bottom blue indicator */}
//                     {isDashboardActive && (
//                       <Box
//                         sx={{
//                           position: "absolute",
//                           bottom: 0,
//                           left: 0,
//                           width: "100%",
//                           height: "2px",
//                           backgroundColor: "#0036DD",
//                         }}
//                       />
//                     )}
//                   </Box>

//                   <Button
//                     disableRipple
//                     onClick={() => {
//                       if (hasUnsavedChanges) {
//                         setNotifMessage(
//                           "You have unsaved changes. Please click SAVE before contacting support.",
//                         );
//                         setUnsavedSnackOpen(true);
//                         setTimeout(() => setUnsavedSnackOpen(false), 3000);
//                         return;
//                       }

//                       // No unsaved changes → proceed
//                       handleContactUs();
//                     }}
//                     sx={{
//                       display: "flex",
//                       padding: "0 0.625rem",
//                       justifyContent: "center",
//                       alignItems: "center",
//                       gap: "0.625rem",
//                       textTransform: "none",
//                       transform: isActive("/contactus-page")
//                         ? "scale(1.1)"
//                         : "scale(1)",
//                       transition: "transform 0.3s ease",
//                     }}
//                   >
//                     <Typography
//                       sx={{
//                         color: "#000",
//                         "& .MuiTypography-root": {
//                           fontFamily: "Montserrat",
//                         },
//                         fontSize: "0.85rem",
//                         fontWeight: isActive("/contactus-page") ? 400 : 400,
//                         textShadow: isActive("/contactus-page")
//                           ? "0 0 1px rgba(0,0,0,0.5)"
//                           : "none",
//                       }}
//                     >
//                       Contact Us
//                     </Typography>
//                   </Button>
//                 </Box>
//                 <Box
//                   sx={{
//                     display: "flex",
//                     flexDirection: "row",
//                     alignItems: "center",
//                     gap: 1,
//                   }}
//                 >
//                   <Box
//                     sx={{
//                       display: "flex",
//                       width: "1.875rem",
//                       height: "1.875rem",
//                       justifyContent: "center",
//                       alignItems: "center",
//                       aspectRatio: "1 / 1",
//                       background: "#0036DD",
//                       borderRadius: "50%", // make it circular
//                       overflow: "hidden",
//                       boxShadow: "0 0 2px rgba(0, 0, 0, 0.15)",
//                     }}
//                   >
//                     {imageUrl ? (
//                       <Box
//                         component="img"
//                         src={imageUrl}
//                         alt={user.name}
//                         sx={{
//                           width: "100%",
//                           height: "100%",
//                           objectFit: "cover",
//                         }}
//                       />
//                     ) : (
//                       <Typography
//                         sx={{
//                           color: "#fff",
//                           "& .MuiTypography-root": {
//                             fontFamily: "Montserrat",
//                           },
//                           fontSize: "0.75rem",
//                           fontWeight: 400,
//                           lineHeight: "normal",
//                         }}
//                       >
//                         {initial}
//                       </Typography>
//                     )}
//                   </Box>
//                   <Typography
//                     sx={{
//                       color: "#000",
//                       fontFeatureSettings: "'liga' off, 'clig' off",
//                       "& .MuiTypography-root": {
//                         fontFamily: "Montserrat",
//                       },
//                       fontSize: "0.75rem",
//                       fontStyle: "normal",
//                       fontWeight: 600,
//                       lineHeight: "normal",
//                     }}
//                   >
//                     {user.name}
//                   </Typography>
//                   <Box
//                     disableRipple
//                     component={Button}
//                     onClick={(e) => handleMenuOpen(e)}
//                     sx={{
//                       width: "0.5625rem",
//                       height: "0.25rem",
//                       aspectRatio: "9 / 4",
//                       justifyContent: "flex-start",
//                     }}
//                   >
//                     <svg
//                       strokeWidth="2px"
//                       stroke="#000"
//                       xmlns="http://www.w3.org/2000/svg"
//                       width="11"
//                       height="6"
//                       viewBox="0 0 11 6"
//                       fill="none"
//                     >
//                       <path
//                         d="M1 1C1 1 4.72596 4.54002 5.00262 4.80287C5.27927 5.06571 5.72662 5.06571 5.99738 4.80287C6.26815 4.54002 10 1 10 1"
//                         stroke="black"
//                         strokeWidth="2"
//                         strokeLinecap="round"
//                       />
//                     </svg>
//                   </Box>
//                 </Box>
//               </Box>
//             </Box>
//             <Box
//               sx={{
//                 position: "relative",
//                 zIndex: 2,
//                 width: "100%",
//                 height: "100%",
//                 display: "flex",
//                 background: "#F5F6F8",
//                 justifyContent: "center",
//                 // alignItems: "center",
//                 //overflow: "hidden",
//               }}
//             >
//               <Outlet />
//             </Box>
//           </Box>
//         </Box>
//         <Menu
//           anchorEl={anchorEl}
//           open={open}
//           onClose={handleMenuClose}
//           slotProps={{
//             paper: {
//               elevation: 3,
//               sx: {
//                 mt: 1,
//                 borderRadius: "0.5rem",
//                 minWidth: "8rem",
//                 p: "0.25rem",
//               },
//             },
//           }}
//         >
//           <MenuItem
//             onClick={() => {
//               handleMenuClose();
//               navigate("profile");
//             }}
//             sx={{
//               "& .MuiTypography-root": {
//                 fontFamily: "Montserrat",
//               },
//               fontSize: "0.75rem",
//               color: "#000",
//               "&:hover": {
//                 backgroundColor: "#f5f5f5",
//               },
//             }}
//           >
//             Profile
//           </MenuItem>
//           <MenuItem
//             onClick={handleLogout}
//             sx={{
//               "& .MuiTypography-root": {
//                 fontFamily: "Montserrat",
//               },
//               fontSize: "0.75rem",
//               color: "#000",
//               "&:hover": {
//                 backgroundColor: "#f5f5f5",
//               },
//             }}
//           >
//             Logout
//           </MenuItem>
//         </Menu>
//         <ContactUsPopup
//           open={Opencontactus}
//           onClose={() => setOpencontactus(false)}
//           prefillData={{
//             email: userData?.emailId,
//             name: userData?.userName,
//             phone: userData?.phoneNumber,
//             userDomain: userData?.userDomain,
//             userRole: userData?.userRole,
//             remarks: userData?.remarks,
//             jobTitle: userData?.jobTitle,
//             organisation: userData?.organisation,
//             emailContact:userData?.contactPreference!=null&&userData?.contactPreference.includes("Email") || false,
//             phoneContact:userData?.contactPreference!=null&&userData?.contactPreference.includes("Phone") || false,
//             isUserLoged:true
//           }}
//         />
//         <WarningBanner
//           open={unsavedSnackOpen}
//           message={notifMessage}
//           onClose={() => setUnsavedSnackOpen(false)}
//         />
//         <SuccessBanner open={successOpen} message={successMessage} />
//       </>
//     </UnsavedContext.Provider>
//   );
// }


import React, { use, useEffect, useState, useContext } from "react";
import {
  Outlet,
  useLocation,
  useNavigate,
  UNSAFE_NavigationContext as NavigationContext,
} from "react-router-dom";
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Box,
  Drawer,
  CssBaseline,
  Tooltip,
  Avatar,
  Menu,
  MenuItem,
  List,
  Button,
  ListItemButton,
  ListItemText,
  Divider,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { motion, AnimatePresence } from "framer-motion";
import LogoutIcon from "@mui/icons-material/Logout";
import logo from "../assets/images/logo.svg";
import favIcon from "../assets/images/favicon_Sandhata.png";
import { useAuth } from "../auth/AuthContext";
import { useApi } from "../api/useApi";
import GradientLayout from "./GradientLayout";
import Greeting from "./Greeting";
import { useRef, useLayoutEffect } from "react";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import ContactUsPopup from "../components/ContactusPage";
export const UnsavedContext = React.createContext({
  hasUnsaved: false,
  setHasUnsaved: () => {},
});

const IconCompleted = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8 1C4.1 1 1 4.1 1 8C1 11.9 4.1 15 8 15C11.9 15 15 11.9 15 8C15 4.1 11.9 1 8 1ZM7 10.7004L4.5 8.20039L5.3 7.40039L7 9.10039L10.7 5.40039L11.5 6.20039L7 10.7004ZM2 8C2 11.3 4.7 14 8 14C11.3 14 14 11.3 14 8C14 4.7 11.3 2 8 2C4.7 2 2 4.7 2 8Z"
      fill="#0067d6ff"
    />
  </svg>
);

const IconHalfFilled = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M8 15C6.14348 15 4.36256 14.2629 3.0498 12.9502C1.73705 11.6374 1 9.85652 1 8C1 6.14348 1.73705 4.36256 3.0498 3.0498C4.36256 1.73705 6.14348 1 8 1V15ZM12.5244 13.3359C11.9037 13.8613 11.1963 14.2746 10.4336 14.5566L10.0918 13.6172C10.7448 13.3749 11.3506 13.0208 11.8818 12.5703L12.5244 13.3359ZM14.8887 9.20605C14.7504 10.0122 14.4739 10.7886 14.0703 11.5L13.2041 11C13.5494 10.3897 13.787 9.72434 13.9053 9.0332L14.8887 9.20605ZM14.0703 4.52246C14.4737 5.22577 14.7504 5.99503 14.8887 6.79395L13.9053 7C13.7871 6.29836 13.5496 5.622 13.2041 5L14.0703 4.52246ZM10.4336 1.44336C11.1963 1.72539 11.9037 2.13871 12.5244 2.66406L11.8818 3.42969C11.3506 2.97911 10.7449 2.6241 10.0918 2.38184L10.4336 1.44336Z"
      fill="#0036DD"
    />
  </svg>
);

const IconNotStarted = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M10.1514 14.6514C9.44847 14.8408 8.72767 14.9577 8.00098 15.001V14.001C8.62977 14.003 9.25465 13.9018 9.85059 13.7012L10.1514 14.6514ZM4.50098 12.8506C5.00708 13.212 5.56324 13.4989 6.15137 13.7012L5.85059 14.6514C5.15363 14.4196 4.49635 14.082 3.90137 13.6514L4.50098 12.8506ZM13.6514 12.1006C13.2124 12.6895 12.6895 13.2124 12.1006 13.6514L11.501 12.8506C12.0227 12.4788 12.4788 12.0227 12.8506 11.501L13.6514 12.1006ZM2.30078 9.90137C2.50301 10.4894 2.78997 11.0448 3.15137 11.5508L2.35059 12.1514C1.91973 11.5562 1.58247 10.8984 1.35059 10.2012L2.30078 9.90137ZM15.001 8.00098C14.9863 8.73055 14.8689 9.45481 14.6514 10.1514L13.7012 9.85059C13.9018 9.25465 14.003 8.62977 14.001 8.00098H15.001ZM2.30078 6.15137C2.1002 6.74731 1.99895 7.37219 2.00098 8.00098H1.00098C0.990995 7.26936 1.10907 6.54127 1.35059 5.85059L2.30078 6.15137ZM13.6006 3.85059C14.0314 4.44568 14.3687 5.10366 14.6006 5.80078L13.6514 6.10059C13.4491 5.51255 13.1622 4.9572 12.8008 4.45117L13.6006 3.85059ZM4.45117 3.15137C3.95619 3.53748 3.51855 3.99179 3.15137 4.50098L2.35059 3.90137C2.77163 3.31376 3.2771 2.79067 3.85059 2.35059L4.45117 3.15137ZM10.1006 1.30078C10.7977 1.53264 11.4557 1.86997 12.0508 2.30078L11.4512 3.10059C10.9451 2.73913 10.3889 2.45321 9.80078 2.25098L10.1006 1.30078ZM8.00098 2.00098C7.37219 1.99895 6.74731 2.1002 6.15137 2.30078L5.85059 1.35059C6.54127 1.10907 7.26936 0.990995 8.00098 1.00098V2.00098Z"
      fill="#DDC9C9"
    />
  </svg>
);

const drawerWidth = 240;

export default function MainLayout() {
  const location = useLocation();
  const navigate = useNavigate();
  const isActive = (path) => location.pathname.includes(path);

  const { user, logout } = useAuth();
  const hideLayout = ["/", "/login"].includes(location.pathname);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [domains, setDomains] = useState([]);
  const { request } = useApi();
  const [activeDomain, setActiveDomain] = useState(user.domain);
  const [Opencontactus, setOpencontactus] = useState(false);
  // const [showInstriction, setShowInstruction] = useState(false);

  const [contactPopupOpen, setContactPopupOpen] = useState(false);
  const [pendingContactClick, setPendingContactClick] = useState(false);
  const [imageUrl, setImgUrl] = useState(null);
  const [initial, setInitial] = useState("XZ");
  const open = Boolean(anchorEl);
  const [assessmentAvailable, setAssessmentAvailable] = useState(true);
  const [checkedCompletion, setCheckedCompletion] = useState(false);
  const [domainAssessmentAllowed, setDomainAssessmentAllowed] = useState(true);
  const sendingRef = useRef(false);

  const [hasCompleted, setHasCompleted] = useState(null);
  const [domainData, setDomainData] = useState([]);

  const [notifMessage, setNotifMessage] = useState("");
  const [unsavedSnackOpen, setUnsavedSnackOpen] = useState(false);

  const pendingCallback = useRef(null);
  const [openConfirm, setOpenConfirm] = useState(false);
  const pendingAction = useRef(null);
  // 🔥 Global flag: Are there unsaved changes in Questions.jsx?
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [activeCategory, setActiveCategory] = useState(null);
  const [categoryStatus, setCategoryStatus] = useState({});
  const [blockTriggered, setBlockTriggered] = useState(false);
  const isQuestionsPage = location.pathname.startsWith("/questions/");
  const [userData, setUserData] = useState();
  const [successOpen, setSuccessOpen] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const isDashboardActive = location.pathname === "/history-page" ? true : false;
  const isLandingActive = location.pathname === "/landing-page" ? true : false;
  const showInstriction = location.pathname !== "/landing-page" ? true : false;

  const handleBlockedNavigation = (nextAction) => {
    if (hasUnsavedChanges) {
      pendingAction.current = nextAction;
      setOpenConfirm(true);
      return false;
    }

    return true;
  };

  const handleYes = () => {
    setOpenConfirm(false);

    const callback = pendingCallback.current;

    setHasUnsavedChanges(false);

    setTimeout(() => {
      if (callback) {
        callback();
      }

      pendingCallback.current = null;
    }, 100);
  };
  const handleNo = () => {
    setOpenConfirm(false);
    pendingCallback.current = null;
  };

  const WarningBanner = ({ open, message, onClose }) => {
    return (
      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ y: 50, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: 50, opacity: 0 }}
            transition={{ duration: 0.4, ease: "easeOut" }}
            style={{
              position: "fixed",
              bottom: "2rem", // stay at bottom
              left: "35%", // center horizontally
              transform: "translateX(-50%)", // perfectly center it
              display: "inline-flex",
              alignItems: "center",
              gap: "1rem",
              borderRadius: "1rem",
              border: "1px solid #D32F2F",
              background: "#D32F2F",
              color: "#FFFFFF",
              // fontFamily: "Akkurat-Bold, sans-serif",
              "& .MuiTypography-root": {
                fontFamily: "Montserrat",
              },
              fontSize: "0.9rem",
              fontWeight: 400,
              padding: "0.75rem 1.25rem",
              zIndex: 2000,
              boxShadow: "0 2px 10px rgba(0, 0, 0, 0.25)",
              textAlign: "center",
              maxWidth: "90%",
            }}
          >
            {/* Warning Icon */}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
            >
              <circle cx="12" cy="12" r="10" stroke="#fff" strokeWidth="2" />
              <line
                x1="12"
                y1="7"
                x2="12"
                y2="13"
                stroke="#fff"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <circle cx="12" cy="17" r="1.3" fill="#fff" />
            </svg>

            {/* Message */}
            <span>{message}</span>

            {/* Close Button */}
            <Box
              onClick={onClose}
              sx={{
                cursor: "pointer",
                ml: 1,
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                stroke="#fff"
                strokeWidth="2"
              >
                <line x1="6" y1="6" x2="18" y2="18" strokeLinecap="round" />
                <line x1="18" y1="6" x2="6" y2="18" strokeLinecap="round" />
              </svg>
            </Box>
          </motion.div>
        )}
      </AnimatePresence>
    );
  };

  const SuccessBanner = ({ open, message }) => {
    return (
      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ y: 50, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: 50, opacity: 0 }}
            transition={{ duration: 0.4, ease: "easeOut" }}
            style={{
              position: "fixed",
              bottom: "2rem",
              left: "35%",
              transform: "translateX(-50%)",
              display: "inline-flex",
              alignItems: "center",
              gap: "1rem",
              borderRadius: "1rem",
              border: "1px solid #00A300",
              background: "#016100",
              color: "#FFFFFF",
              // fontFamily: "Akkurat-Bold, sans-serif",
              fontSize: "0.9rem",
              fontWeight: 400,
              padding: "0.75rem 1.25rem",
              zIndex: 2000,
              boxShadow: "0 2px 10px rgba(0, 0, 0, 0.25)",
              textAlign: "center",
              maxWidth: "90%",
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10 1.25C5.125 1.25 1.25 5.125 1.25 10C1.25 14.875 5.125 18.75 10 18.75C14.875 18.75 18.75 14.875 18.75 10C18.75 5.125 14.875 1.25 10 1.25ZM8.75 13.75L5.375 10.375L6.5 9.375L8.75 11.625L13.75 6.75L14.875 7.75L8.75 13.75Z"
                fill="#24A148"
              />
            </svg>

            <span>{message}</span>
          </motion.div>
        )}
      </AnimatePresence>
    );
  };

  // Track previous route inside the SPA
  const previousPath = useRef("");
  const pendingRoute = useRef(null);
  const originalPushRef = useRef(null);
  const { navigator } = useContext(NavigationContext);
  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (!hasUnsavedChanges) return;
      e.preventDefault();
      e.returnValue = "";
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => window.removeEventListener("beforeunload", handleBeforeUnload);
  }, [hasUnsavedChanges]);

  useEffect(() => {
    async function fetchDomains() {
      const data = await request({
        url: "/categories/domains-with-categories",
      });

      // Full data (domain + categories)
      setDomainData(data);

      // Keep names array — your existing logic depends on this
      const domainNames = data.map((item) => item.name);
      setDomains(domainNames);
    }
    fetchDomains();
    const initials = user.name
      ? user.name
          .split(" ")
          .map((n) => n[0])
          .join("")
          .substring(0, 2)
          .toUpperCase()
      : "";
    setInitial(initials);
  }, []);

  useEffect(() => {
    if (!location.pathname.startsWith("/questions/")) return;

    // Wait for Questions.jsx to update localStorage
    const timer = setTimeout(() => {
      const saved = localStorage.getItem("activeCategory");
      setActiveCategory(saved);
    }, 50);

    return () => clearTimeout(timer);
  }, [location.pathname]);

  // Listen for category change updates from Questions.jsx
  useEffect(() => {
    const handler = () => {
      const saved = localStorage.getItem("activeCategory");
      setActiveCategory(saved);
    };

    window.addEventListener("storage", handler);
    return () => window.removeEventListener("storage", handler);
  }, []);

  useEffect(() => {
    const handler = () => {
      const saved = localStorage.getItem("activeCategory");
      setActiveCategory(saved);
    };

    window.addEventListener("activeCategoryChanged", handler);
    return () => window.removeEventListener("activeCategoryChanged", handler);
  }, []);

  useEffect(() => {
    const handler = () => {
      const savedStatus = localStorage.getItem("categoryStatus");
      if (savedStatus) {
        setCategoryStatus(JSON.parse(savedStatus));
      }
    };

    window.addEventListener("categoryStatusUpdated", handler);

    return () => window.removeEventListener("categoryStatusUpdated", handler);
  }, []);

  useEffect(() => {
    let urlDomain = null;

    // Case 1: Question pages → /questions/DevOps
    if (location.pathname.startsWith("/questions/")) {
      urlDomain = location.pathname.split("/")[2];
    }

    // Case 2: Score pages → /sre-score?domain=DevOps
    if (
      location.pathname.startsWith("/sre-score") ||
      location.pathname.startsWith("/devops-score")
    ) {
      const params = new URLSearchParams(location.search);
      urlDomain = params.get("domain");
    }

    if (urlDomain) {
      const matched = domains.find(
        (d) => d.toLowerCase() === urlDomain.toLowerCase(),
      );
      if (matched) setActiveDomain(matched);
    }
  }, [location.pathname, domains]);

  useEffect(() => {
    if (!user?.email) return;

    async function checkStatus() {
      try {
        const res = await request({
          url: `evaluations/has-completed/${user.email}`,
          method: "GET",
        });

        setHasCompleted(res);
        // If user has completed → redirect ONCE only
        // if (res === true) {
        //   setShowInstruction(true)
        //   if (!location.pathname.startsWith("/history-page")) {
        //     navigate("/history-page", { replace: true });
        //   }
        // }
        //  if (res === false) {
        //   setShowInstruction(false);
        // Don't force the Home-page bounce if the user is already headed to
        // a specific domain's assessment (e.g. arriving via the "resume my
        // assessment" or "view your evaluation" email links) — only redirect
        // when they're on none of the recognized deep-link destinations.
        // Treat a malformed /questions/null, /questions/undefined, or a
        // missing ?domain= as invalid too, so a bad value doesn't strand the
        // user on a broken page.
        const urlDomainSegment = location.pathname.startsWith("/questions/")
          ? location.pathname.split("/")[2]
          : null;
        const isValidQuestionsPage =
          urlDomainSegment &&
          urlDomainSegment !== "null" &&
          urlDomainSegment !== "undefined";

        const isScorePage =
          location.pathname.startsWith("/sre-score") ||
          location.pathname.startsWith("/devops-score");
        const scorePageDomain = isScorePage
          ? new URLSearchParams(location.search).get("domain")
          : null;
        const isValidScorePage =
          isScorePage &&
          scorePageDomain &&
          scorePageDomain !== "null" &&
          scorePageDomain !== "undefined";

        if (
          !location.pathname.startsWith("/landing-page") &&
          !isValidQuestionsPage &&
          !isValidScorePage
        ) {
          navigate("/landing-page", { replace: true });
        }
        // }
      } catch (err) {
        console.error(err);
      }

      setCheckedCompletion(true);
    }

    checkStatus();
  }, [user?.email]);

  useLayoutEffect(() => {
    if (!checkedCompletion) return;

    const isQuestionsPage = location.pathname.startsWith("/questions/");
    const isMaturityAssessmentPage = location.pathname.startsWith("/sre-score");

    if (hasCompleted === false) return;

    const allowedPrev = [
      "/history-page",
      "/final-page",
      "/sre-score",
      "/devops-score",
    ];

    const cameFromAllowed = allowedPrev.some((p) =>
      previousPath.current.startsWith(p),
    );

    const lastPath = previousPath.current;
    previousPath.current = location.pathname;

    if (isQuestionsPage) {
      // Allow switching between domain question pages
      const cameFromQuestions = previousPath.current.startsWith("/questions/");

      if (cameFromQuestions) {
        // allow navigation
        previousPath.current = location.pathname;
        return;
      }

      // Otherwise fall back to strict rule
      if (!cameFromAllowed) {
        navigate("/history-page");
      }
    }
  }, [location.pathname, checkedCompletion, hasCompleted]);

  if (!checkedCompletion) return null;

  if (hideLayout || !user) return <Outlet />;

const showUnsavedChangesDialog = (onYes) => {
    pendingCallback.current = onYes;
    setOpenConfirm(true);
  };

  const handleClick = async (domain) => {
    if (hasUnsavedChanges) {
      showUnsavedChangesDialog(() => {
        // continue action here
        navigate(`/questions/${domain}`);
        console.log("User clicked YES");
      });
    }

    try {
      const res = await request({
        url: `/evaluations/has-completed/${user.email}?domain=${domain}`,
        method: "GET",
      });

      setDomainAssessmentAllowed(res);
    } catch (err) {
      console.error("Domain assessment check failed:", err);
      setDomainAssessmentAllowed(false);
    }

    // ✔ Only navigate — highlight will update in useEffect after navigation succeeds
    navigate(`/questions/${domain}`);
  };

  function NavigationBlocker({ when, onBlock }) {
    const { navigator } = useContext(NavigationContext);

    useEffect(() => {
      if (!when) return;

      const originalPush = navigator.push;

      navigator.push = (...args) => {
        onBlock(args, originalPush);
        return; // block navigation
      };

      return () => {
        navigator.push = originalPush;
      };
    }, [when, onBlock, navigator]);

    return null;
  }

  const handleDrawerToggle = () => setMobileOpen(!mobileOpen);
  const handleMenuOpen = (event) => setAnchorEl(event.currentTarget);
  const handleMenuClose = () => setAnchorEl(null);
  //const handleLogout = () => {};
  const handleLogout = () => {
    if (hasUnsavedChanges) {
      setNotifMessage(
        "You have unsaved changes. Please click SAVE before continuing.",
      );
      setUnsavedSnackOpen(true);

      setTimeout(() => setUnsavedSnackOpen(false), 3000);
      return; // ⛔ block logout
    }

    logout(); // ✔ safe logout
  };

  // Dynamic greeting
  const greeting = (() => {
    const hour = new Date().getHours();
    if (hour < 12) return "Good Morning";
    if (hour < 18) return "Good Afternoon";
    return "Good Evening";
  })();

  const avatarSrc = user?.imageUrl || user?.photo || null;
  const initials =
    user?.name
      ?.split(" ")
      ?.map((n) => n[0])
      .join("")
      .substring(0, 2)
      .toUpperCase() || "NA";

  const menuItems = [
    { text: "DevOps Questions", path: "/devops-questions", domain: "DevOps" },
    {
      text: "Questionaire",
      path: `/sre-questions?email=${user.email}&domain=${user.domain}`,
      domain: "SRE",
    },
    { text: "DevOps Score", path: "/devops-score", domain: "DevOps" },
    {
      text: "Maturity Assessment",
      path: `/sre-score?email=${user.email}&domain=${user.domain}`,
      domain: "SRE",
    },
    { text: "Contact Us", path: "/contactus-page", domain: "All" },
  ];

  const bottomItem = { text: "Preview Instructions", path: "/instructions" };

  const filteredMenuItems = menuItems.filter(
    (item) => item.domain === user.domain || item.domain === "All",
  );

  const handleContactUs = async () => {
    if (sendingRef.current) return; // ⛔ prevent double-click
    sendingRef.current = true;

    try {
      const requests = await request({
        url: "/user/by-email",
        method: "GET",
        params: { email: user.email },
      });

      if (requests[0]?.emailId) {
        //   await request({
        //   url: `user/logout?email=${requests[0]?.emailId}`,
        //   method: "GET",
        // });
        // sessionStorage.removeItem("user");
        // // navigate("/");
        setUserData(requests[0]);
        setOpencontactus(true)
        // navigate("/contactus-page", {
        //   state: {
        //     // email: user?.email,
        //     // name: user?.name,
        //     email: requests[0]?.emailId,
        //     name: requests[0]?.userName,
        //     phone:requests[0]?.phoneNumber,
        //     userDomain:requests[0]?.userDomain,
        //     userRole:requests[0]?.userRole,
        //     remarks:requests[0]?.remarks,
        //     jobTitle:requests[0]?.jobTitle,
        //     organisation:requests[0]?.organisation,
        //     // userLogedIn:true
        //   },
        // });
        // navigate("/contactus-page");
        // sendingRef.current = false;
        // return;
      }

      // Check if user exists
      // const res = await request({
      //   url: "/user/exists",
      //   method: "GET",
      //   params: { email: user.email },
      // });

      // if (res.exists) {
      //   // Trigger email once
      //   await request({
      //     url: "/contact/trigger-email",
      //     method: "POST",
      //     params: {
      //       email: user.email,
      //       name: user.name || "User",
      //     },
      //   });

      //   // Show green success banner
      //   setSuccessMessage("Thank you! We will contact you shortly.");
      //   setSuccessOpen(true);

      //   setTimeout(() => setSuccessOpen(false), 3000);
      // } else {
      //   navigate("/contactus-page");
      // }
    } catch (err) {
      console.error(err);
      setNotifMessage("Unable to process request. Try again.");
      setUnsavedSnackOpen(true);
    }
    setTimeout(() => {
      sendingRef.current = false; // unlock after 400ms
    }, 400);
  };

  // Sidebar
  const drawer = (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "85%",
        py: 2,
        backgroundColor: "whitesmoke",
        color: "black",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      {/* === Top Section === */}
      <Box sx={{ width: "100%", textAlign: "center" }}>
        <Box
          component="img"
          src={logo}
          alt="Portal Logo"
          sx={{
            width: "160px",
            height: "auto",
            filter: "drop-shadow(0 2px 3px rgba(0,0,0,0.2))",
          }}
        />

        <Box sx={{ mt: 3, px: 2, textAlign: "left" }}>
          <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1 }}>
            Domain
          </Typography>

          {domains.map((domain) => {
            const isQuestionsPage = location.pathname.startsWith("/questions/");

            return (
              <ListItemButton
                key={domain}
                disableRipple
                sx={{
                  p: 1,
                  "&.Mui-selected": {
                    backgroundColor: "transparent",
                  },
                  "&.Mui-focusVisible": {
                    backgroundColor: "transparent",
                  },
                  "&:hover": {
                    backgroundColor: "transparent",
                  },
                }}
                selected={isQuestionsPage && activeDomain === domain}
                //onClick={() => navigate(`/${domain.toLowerCase()}-questions`)}
                onClick={() => handleClick(domain)}
              >
                <ListItemText
                  slotProps={{
                    primary: {
                      sx: {
                        borderRight:
                          isQuestionsPage && activeDomain === domain
                            ? "3px solid #1976d2"
                            : "none",

                        color:
                          isQuestionsPage && activeDomain === domain
                            ? "#0036DD"
                            : "#000",

                        // fontFamily:
                        //   isQuestionsPage && activeDomain === domain
                        //     ? "Akkurat-Bold"
                        //     : "Akkurat",

                        fontWeight:
                          isQuestionsPage && activeDomain === domain
                            ? "700"
                            : "400",
                      },
                    },
                  }}
                  primary={domain}
                />
              </ListItemButton>
            );
          })}
        </Box>
      </Box>

      {/* === Bottom Section (Preview Instructions) === */}
      <Box sx={{ width: "100%", textAlign: "left" }}>
        <Button
          fullWidth
          onClick={() => navigate(bottomItem.path)}
          sx={{
            textTransform: "none",
            color: "black",
            fontWeight: 500,
            "&:hover": { color: "#1976d2" },
          }}
        >
          {bottomItem.text}
        </Button>
      </Box>
    </Box>
  );
  const handleCategoryClick = (catName) => {
    localStorage.setItem("activeStepCategory", catName);
    window.dispatchEvent(new Event("localStorageChange"));
  };
  return (
    <UnsavedContext.Provider
      value={{
        hasUnsaved: hasUnsavedChanges,
        setHasUnsaved: setHasUnsavedChanges,
      }}
    >
      <>
        {/* 🔥 Navigation blocker added here */}
        <NavigationBlocker
          when={hasUnsavedChanges}
          onBlock={(args) => {
            const nextLocation = args[0];

            showUnsavedChangesDialog(() => {
              navigate(nextLocation.pathname);
            });
          }}
        />

        <Dialog open={openConfirm} onClose={handleNo}>
          <DialogTitle>Unsaved Changes</DialogTitle>

          <DialogContent>
            <DialogContentText>
              You have unsaved changes. Do you want to leave this page?
            </DialogContentText>
          </DialogContent>

          <DialogActions>
            <Button onClick={handleNo}>No</Button>

            <Button onClick={handleYes} variant="contained" color="primary">
              Yes
            </Button>
          </DialogActions>
        </Dialog>

        {/* <Box sx={{ display: "flex", height: "100vh", scrollbarWidth: "none", scrollbarHeight: "none" }}> */}
        <Box
          sx={{
            display: "flex",
            height: "100vh",
            overflow: "hidden", // ⛔ Hides entire page vertical scroll
          }}
        >
          {/* Mobile Drawer */}
          <Drawer
            anchor="left"
            open={mobileOpen}
            onClose={() => setMobileOpen(false)}
            ModalProps={{ keepMounted: true }}
            sx={{
              display: { xs: "block", md: "none" },
              "& .MuiDrawer-paper": {
                width: "13.125rem",
                boxSizing: "border-box",
                padding: "1rem 0 1rem 1rem",
              },
            }}
          >
            <Box sx={{ display: "flex", flexDirection: "column", height: "100%", gap: "1rem", overflowY: "auto" }}>
              <Box component="img" src={logo} alt="Logo" sx={{ width: "120px", height: "22.4px", flexShrink: 0 }} />
              {/* Nav links — always visible at top */}
              <Box sx={{ pl: 2, flexShrink: 0 }}>
                {[
                  { label: "Home", path: "/landing-page" },
                  { label: "Dashboard", path: "/history-page" },
                  { label: "Contact Us", action: () => handleContactUs() },
                  { label: "Instruction", path: "/instructions" },
                ].map(({ label, path, action }) => (
                  <Button
                    key={label}
                    onClick={() => { if (action) { action(); } else { navigate(path); } setMobileOpen(false); }}
                    sx={{ display: "flex", textTransform: "none", color: "#1F2A54", justifyContent: "flex-start", fontSize: "0.875rem", width: "100%", py: 0.5 }}
                  >
                    {label}
                  </Button>
                ))}
              </Box>
              <Divider sx={{ flexShrink: 0 }} />
              <Box sx={{ display: "flex", flexDirection: "column", pl: 2, flex: 1 }}>
                <Box>
                  <Typography sx={{ fontSize: "0.875rem", fontWeight: 700, color: "#1F2A54", mb: 1 }}>
                    Domains
                  </Typography>
                  <Divider sx={{ mb: "16px" }} />
                  {domainData.map((d) => {
                    const domain = d.name;
                    const isActive = activeDomain === domain;
                    const isQuestionsPage = location.pathname.startsWith("/questions/");
                    const lastSavedStep = localStorage.getItem("activeCategory");
                    const sortedCats = [...d.categories].sort((a, b) =>
                      b.weightage !== a.weightage
                        ? b.weightage - a.weightage
                        : a.name.localeCompare(b.name),
                    );
                    const activeStepIndex = sortedCats.findIndex((item) => item.name === lastSavedStep);
                    return (
                      <Box key={domain} sx={{ width: "100%" }}>
                        <Box
                          onClick={() => { handleClick(domain); }}
                          sx={{
                            height: "32px",
                            display: "flex",
                            alignItems: "center",
                            cursor: "pointer",
                            borderLeft: isActive ? "3px solid #0036DD" : "3px solid transparent",
                            backgroundColor: isActive ? "#F6F8FF" : "transparent",
                            "&:hover": { backgroundColor: "#f5f5f5" },
                            mb: 1,
                          }}
                        >
                          <Typography sx={{ fontSize: "0.75rem", pl: 1, color: isActive ? "#0036DD" : "#000", fontFamily: "Akkurat-Bold" }}>
                            {domain}
                          </Typography>
                        </Box>
                        {/* Category sub-list — shown on questions page for active domain */}
                        {isQuestionsPage && isActive && (
                          <Box sx={{ display: "flex", flexDirection: "column", pl: 0 }}>
                            {sortedCats.map((cat, index) => {
                              const isCompleted = categoryStatus?.[cat.name]?.allAnswered;
                              const hasProgress = categoryStatus?.[cat.name]?.anyAnswered;
                              const isActiveCategory = index === activeStepIndex;
                              return (
                                <Box
                                  key={cat.id}
                                  onClick={() => { handleCategoryClick(cat.name); setMobileOpen(false); }}
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "0.4rem",
                                    cursor: "pointer",
                                    p: 1,
                                    borderLeft: isActiveCategory || isCompleted
                                      ? "3px solid #0036DD"
                                      : "3px solid transparent",
                                  }}
                                >
                                  {isCompleted ? (
                                    <IconCompleted />
                                  ) : hasProgress ? (
                                    <IconHalfFilled />
                                  ) : (
                                    <IconNotStarted />
                                  )}
                                  <Typography sx={{ fontSize: "0.75rem", color: "#000", fontFamily: "Akkurat-Pro" }}>
                                    {cat.name}
                                  </Typography>
                                </Box>
                              );
                            })}
                          </Box>
                        )}
                      </Box>
                    );
                  })}
                </Box>
              </Box>
            </Box>
          </Drawer>

          {/* Sidebar — hidden on mobile */}
          <Box
            sx={{
              display: { xs: "none", md: "flex" },
              flexDirection: "column",
              alignItems: "flex-start",
              width: "13.125rem",
              // height: "100%",
              padding: "1rem 0 1rem 1rem",
              gap: "1.5rem",
              flexShrink: 0,
              backgroundColor: "#FFF",
              boxShadow: "1px 0 2px 0 rgba(0, 0, 0, 0.10)",
              zIndex: 4,
            }}
          >
            {/* Logo */}
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                gap: "0.625rem", // 10px
              }}
            >
              <Box
                component="img"
                src={logo}
                alt="Logo"
                sx={{
                  width: "120px", // 120px
                  height: "22.4px", // ~22px
                  // objectFit: "contain",   // keeps the logo proportional
                }}
              />
            </Box>

            {/* List Items */}
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                pl: 2,
                height: "100%",
              }}
            >
              <Box>
                <Box
                  sx={{
                    display: "flex",
                    padding: "0.375rem 0", // 6px top & bottom
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "0.625rem", // 10px gap between items
                    alignSelf: "stretch", // take full width of parent
                  }}
                >
                  <Typography
                    sx={{
                      width: "11.375rem", // 182px
                      color: "#1F2A54",
                      "& .MuiTypography-root": {
                        fontFamily: "Montserrat",
                      },
                      fontSize: "0.875rem", // 14px
                      fontWeight: 700,
                      fontStyle: "normal",
                      lineHeight: "normal",
                      fontFeatureSettings: "'liga' off, 'clig' off",
                    }}
                  >
                    Domains
                  </Typography>
                </Box>
                <Divider sx={{ color: "light grey", mt: 1, mb: "24px" }} />
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "1rem",
                    px: 0,
                  }}
                >
                  {domainData.map((d) => {
                    const domain = d.name;
                    const isQuestionsPage =
                      location.pathname.startsWith("/questions/");
                    const shouldHighlightDomain =
                      isQuestionsPage && activeDomain === domain;
                    let sortedData = [...d.categories].sort((a, b) =>
                      b.weightage !== a.weightage
                        ? b.weightage - a.weightage
                        : a.name.localeCompare(b.name),
                    );
                    const lastSavedStep =
                      localStorage.getItem("activeCategory");
                    // console.log("lastSavedStep=====>",lastSavedStep)
                    let activeStepindex = sortedData.findIndex(
                      (item) => item.name == lastSavedStep,
                    );
                    return (
                      <Box key={domain} sx={{ width: "100%" }}>
                        {/* ===== Domain Title ===== */}
                        <Box
                          onClick={() => handleClick(domain)}
                          sx={{
                            display: "flex",
                            gap: "0.25rem",
                            alignItems: "center",
                            height: "32px",
                            cursor: "pointer",
                            //pl: 1,

                            borderLeft: shouldHighlightDomain
                              ? "3px solid #0036DD"
                              : "3px solid transparent",
                            backgroundColor: shouldHighlightDomain
                              ? "#F6F8FF"
                              : "transparent",
                            "&:hover": { backgroundColor: "#f5f5f5" },
                          }}
                        >
                          <Typography
                            sx={{
                              fontSize: "0.75rem",
                              pl: shouldHighlightDomain ? 1 : 0,
                              fontFamily: shouldHighlightDomain
                                ? "Akkurat-Bold"
                                : "Akkurat-Bold",
                              fontWeight: shouldHighlightDomain ? 400 : 400,
                              color: shouldHighlightDomain ? "#0036DD" : "#000",
                            }}
                          >
                            {domain}
                          </Typography>
                        </Box>

                        {/* ===== Categories under Active Domain ===== */}
                        {isQuestionsPage && activeDomain === domain && (
                          <Box
                            sx={{
                              mt: 0,
                              display: "flex",
                              flexDirection: "column",
                              pl: 0,
                            }}
                          >
                            {[...d.categories]
                              .sort((a, b) =>
                                b.weightage !== a.weightage
                                  ? b.weightage - a.weightage
                                  : a.name.localeCompare(b.name),
                              )
                              .map((cat, index) => {
                                // activeCategory === cat.name;
                                const isCompleted =
                                  categoryStatus?.[cat.name]?.allAnswered;
                                const hasProgress =
                                  categoryStatus?.[cat.name]?.anyAnswered;
                                const isActiveCategory =
                                  index == activeStepindex;

                                return (
                                  <Box
                                    key={cat.id}
                                    sx={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "0.4rem",
                                      // py: "2px",
                                      cursor: "default",
                                      p: 1,
                                      borderLeft:
                                        isActiveCategory || isCompleted
                                          ? "3px solid #0036DD"
                                          : "3px solid transparent",
                                    }}
                                    onClick={() =>
                                      handleCategoryClick(cat.name)
                                    }
                                  >
                                    {/* ===== Icon : Completed / Half / Empty ===== */}
                                    {isCompleted ? (
                                      <IconCompleted />
                                    ) : hasProgress ? (
                                      <IconHalfFilled />
                                    ) : (
                                      <IconNotStarted />
                                    )}

                                    {/* ===== Category Text ===== */}
                                    <Typography
                                      sx={{
                                        fontSize: "0.75rem",
                                        color: "#000",
                                        fontFamily: "Akkurat-Pro",
                                        fontWeight: isActiveCategory
                                          ? 400
                                          : 400,
                                        pt: 0,
                                      }}
                                    >
                                      {cat.name}
                                    </Typography>
                                  </Box>
                                );
                              })}
                          </Box>
                        )}
                      </Box>
                    );
                  })}
                </Box>
              </Box>
              {/* {showInstriction && ( */}
                <Box sx={{ display: "flex" }}>
                  <Box
                    disableRipple
                    component={Button}
                    onClick={() => navigate("/instructions")}
                    sx={{
                      width: "11.375rem",
                      mb: 0,
                      flexShrink: 0,
                      p: 0,
                      m: 0,
                      textTransform: "none",
                      display: "flex",
                      justifyContent: "flex-start",
                    }}
                  >
                    <Typography
                      sx={{
                        color: "#1F2A54",
                        // fontFamily: "Montserrat",
                        "& .MuiTypography-root": {
                          fontFamily: "Montserrat",
                        },
                        fontSize: "0.875rem", // 14px
                        fontWeight: 400,
                        fontStyle: "normal",
                        lineHeight: "normal",
                        fontFeatureSettings: "'liga' off, 'clig' off",
                      }}
                    >
                      Instruction
                    </Typography>
                  </Box>
                </Box>
              {/* )} */}
            </Box>
          </Box>

          {/* Main content area */}
          <Box sx={{ flexGrow: 1, minWidth: 0, display: "flex", flexDirection: "column", overflowX: "hidden" }}>
            {/* AppBar */}
            <Box
              sx={{
                display: "flex",

                width: "auto",
                height: "2.875rem",
                // padding: "0 4rem 0 1.5rem",
                alignItems: "center",
                gap: "1.5rem",
                flexShrink: 0,
                background: "#FFF",
                boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.10)",
                zIndex: 4,
              }}
            >
              {/* Navigation and profile */}
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                <Box sx={{ display: "flex", flexDirection: "row", gap: 1, alignItems: "center" }}>
                  {/* Hamburger — mobile only */}
                  <IconButton
                    onClick={() => setMobileOpen(true)}
                    sx={{ display: { xs: "flex", md: "none" }, p: "4px" }}
                  >
                    <MenuIcon fontSize="small" />
                  </IconButton>
                  {/* Greeting */}
                  <Box
                    sx={{
                      display: { xs: "none", md: "flex" },
                      padding: "0 0.625rem",
                      justifyContent: "center",
                      alignItems: "center",
                      gap: "0.625rem",
                      alignSelf: "stretch",
                    }}
                  >
                    <Typography
                      sx={{
                        color: "#000",
                        fontFamily: "Akkurat-Bold",
                        fontSize: "0.75rem", // 12px
                        fontWeight: 400,
                        fontStyle: "normal",
                        lineHeight: "normal",
                        fontFeatureSettings: "'liga' off, 'clig' off",
                      }}
                    >
                      <Greeting />
                    </Typography>
                  </Box>
                  <Box
                    disableRipple
                    component={Button}
                    onClick={() => {
                      navigate("/landing-page");
                    }}
                    sx={{
                      position: "relative",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      px: "0.75rem",
                      height: "100%",
                      textTransform: "none",
                      borderRadius: 0,

                      backgroundColor: isLandingActive
                        ? "#EEF3FF"
                        : "transparent",

                      "&:hover": {
                        backgroundColor: isLandingActive
                          ? "#EEF3FF"
                          : "transparent",
                      },
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: "0.85rem",
                        fontFamily: "Akkurat-Pro",
                        fontWeight: 500,
                        color: isLandingActive ? "#0036DD" : " #000",
                      }}
                    >
                      Home
                    </Typography>

                    {isLandingActive && (
                      <Box
                        sx={{
                          position: "absolute",
                          bottom: 0,
                          left: 0,
                          width: "100%",
                          height: "2px",
                          backgroundColor: "#0036DD",
                        }}
                      />
                    )}
                  </Box>
                  <Box
                    disableRipple
                    component={Button}
                    onClick={() => navigate("/history-page")}
                    sx={{
                      position: "relative",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      px: "0.75rem",
                      height: "100%",
                      textTransform: "none",
                      borderRadius: 0,

                      backgroundColor: isDashboardActive
                        ? "#EEF3FF"
                        : "transparent",

                      "&:hover": {
                        backgroundColor: isDashboardActive
                          ? "#EEF3FF"
                          : "transparent",
                      },
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: "0.85rem",
                        fontFamily: "Akkurat-Pro",
                        fontWeight: 500,
                        color: isDashboardActive ? "#0036DD" : "#000",
                      }}
                    >
                      Dashboard
                    </Typography>

                    {/* ✅ Bottom blue indicator */}
                    {isDashboardActive && (
                      <Box
                        sx={{
                          position: "absolute",
                          bottom: 0,
                          left: 0,
                          width: "100%",
                          height: "2px",
                          backgroundColor: "#0036DD",
                        }}
                      />
                    )}
                  </Box>

                  <Button
                    disableRipple
                    onClick={() => {
                      if (hasUnsavedChanges) {
                        setNotifMessage(
                          "You have unsaved changes. Please click SAVE before contacting support.",
                        );
                        setUnsavedSnackOpen(true);
                        setTimeout(() => setUnsavedSnackOpen(false), 3000);
                        return;
                      }

                      // No unsaved changes → proceed
                      handleContactUs();
                    }}
                    sx={{
                      display: "flex",
                      padding: "0 0.625rem",
                      justifyContent: "center",
                      alignItems: "center",
                      gap: "0.625rem",
                      textTransform: "none",
                      transform: isActive("/contactus-page")
                        ? "scale(1.1)"
                        : "scale(1)",
                      transition: "transform 0.3s ease",
                    }}
                  >
                    <Typography
                      sx={{
                        color: "#000",
                        "& .MuiTypography-root": {
                          fontFamily: "Montserrat",
                        },
                        fontSize: "0.85rem",
                        fontWeight: isActive("/contactus-page") ? 400 : 400,
                        textShadow: isActive("/contactus-page")
                          ? "0 0 1px rgba(0,0,0,0.5)"
                          : "none",
                      }}
                    >
                      Contact Us
                    </Typography>
                  </Button>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    gap: 1,
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      width: "1.875rem",
                      height: "1.875rem",
                      justifyContent: "center",
                      alignItems: "center",
                      aspectRatio: "1 / 1",
                      background: "#0036DD",
                      borderRadius: "50%", // make it circular
                      overflow: "hidden",
                      boxShadow: "0 0 2px rgba(0, 0, 0, 0.15)",
                    }}
                  >
                    {imageUrl ? (
                      <Box
                        component="img"
                        src={imageUrl}
                        alt={user.name}
                        sx={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                        }}
                      />
                    ) : (
                      <Typography
                        sx={{
                          color: "#fff",
                          "& .MuiTypography-root": {
                            fontFamily: "Montserrat",
                          },
                          fontSize: "0.75rem",
                          fontWeight: 400,
                          lineHeight: "normal",
                        }}
                      >
                        {initial}
                      </Typography>
                    )}
                  </Box>
                  <Typography
                    sx={{
                      display: { xs: "none", md: "block" },
                      color: "#000",
                      fontFeatureSettings: "'liga' off, 'clig' off",
                      "& .MuiTypography-root": {
                        fontFamily: "Montserrat",
                      },
                      fontSize: "0.75rem",
                      fontStyle: "normal",
                      fontWeight: 600,
                      lineHeight: "normal",
                    }}
                  >
                    {user.name}
                  </Typography>
                  <Box
                    disableRipple
                    component={Button}
                    onClick={(e) => handleMenuOpen(e)}
                    sx={{
                      width: "0.5625rem",
                      height: "0.25rem",
                      aspectRatio: "9 / 4",
                      justifyContent: "flex-start",
                    }}
                  >
                    <svg
                      strokeWidth="2px"
                      stroke="#000"
                      xmlns="http://www.w3.org/2000/svg"
                      width="11"
                      height="6"
                      viewBox="0 0 11 6"
                      fill="none"
                    >
                      <path
                        d="M1 1C1 1 4.72596 4.54002 5.00262 4.80287C5.27927 5.06571 5.72662 5.06571 5.99738 4.80287C6.26815 4.54002 10 1 10 1"
                        stroke="black"
                        strokeWidth="2"
                        strokeLinecap="round"
                      />
                    </svg>
                  </Box>
                </Box>
              </Box>
            </Box>
            <Box
              sx={{
                position: "relative",
                zIndex: 2,
                width: "100%",
                height: "100%",
                display: "flex",
                background: "#F5F6F8",
                justifyContent: "center",
                overflowY: { xs: "auto", md: "hidden" },
              }}
            >
              <Outlet />
            </Box>
          </Box>
        </Box>
        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={handleMenuClose}
          slotProps={{
            paper: {
              elevation: 3,
              sx: {
                mt: 1,
                borderRadius: "0.5rem",
                minWidth: "8rem",
                p: "0.25rem",
              },
            },
          }}
        >
          <MenuItem
            onClick={() => {
              handleMenuClose();
              navigate("profile");
            }}
            sx={{
              "& .MuiTypography-root": {
                fontFamily: "Montserrat",
              },
              fontSize: "0.75rem",
              color: "#000",
              "&:hover": {
                backgroundColor: "#f5f5f5",
              },
            }}
          >
            Profile
          </MenuItem>
          <MenuItem
            onClick={handleLogout}
            sx={{
              "& .MuiTypography-root": {
                fontFamily: "Montserrat",
              },
              fontSize: "0.75rem",
              color: "#000",
              "&:hover": {
                backgroundColor: "#f5f5f5",
              },
            }}
          >
            Logout
          </MenuItem>
        </Menu>
        <ContactUsPopup
          open={Opencontactus}
          onClose={() => setOpencontactus(false)}
          prefillData={{
            email: userData?.emailId,
            name: userData?.userName,
            phone: userData?.phoneNumber,
            userDomain: userData?.userDomain,
            userRole: userData?.userRole,
            remarks: userData?.remarks,
            jobTitle: userData?.jobTitle,
            organisation: userData?.organisation,
            emailContact:userData?.contactPreference!=null&&userData?.contactPreference.includes("Email") || false,
            phoneContact:userData?.contactPreference!=null&&userData?.contactPreference.includes("Phone") || false,
            isUserLoged:true
          }}
        />
        <WarningBanner
          open={unsavedSnackOpen}
          message={notifMessage}
          onClose={() => setUnsavedSnackOpen(false)}
        />
        <SuccessBanner open={successOpen} message={successMessage} />
      </>
    </UnsavedContext.Provider>
  );
}